import React from "react";
import { Box, Cloud, CreditCard, Cpu, Database, Globe, Mail, Server } from "lucide-react";
import { eC } from "../../lib/helpers";

export const SI = ({ name, sz = 15 }: { name: string; sz?: number }) => {
  const p = { size: sz, strokeWidth: 1.5, style: { color: eC(name) } };
  return name === "railway" ? <Server {...p} /> : name === "supabase" ? <Database {...p} /> :
    name === "netlify" ? <Globe {...p} /> : name === "stripe" ? <CreditCard {...p} /> :
    name === "mailgun" ? <Mail {...p} /> : name === "cloudflare" ? <Cloud {...p} /> :
    name === "manus" ? <Cpu {...p} /> : <Box {...p} />;
};
